import { Serializable } from '@/models/core/serializable';

export class GrowingPurpose implements Serializable<GrowingPurpose> {
  growingPurposeID: number;
  title: string;

  deserialize(input: any): GrowingPurpose {
    this.growingPurposeID = input.growingPurposeID;
    this.title = input.title;
    return this;
  }
}
